<template lang="pug">
  div
    div.label.basic600--text.text-uppercase Status
    div.mt-2
      y-checkbox(v-model="processing" :color="$vuetify.theme.themes[$theme].info500")
        template(v-slot:label)
          div.p2.my-auto {{ $t('processing') }}
    template(v-if="processing")
      v-row.mt-2(no-gutters)
        v-col(cols="1")
        v-col
          y-checkbox(v-model="processingArranged" :color="$vuetify.theme.themes[$theme].info500")
            template(v-slot:label)
              div.p2.my-auto {{ $t('arranged') }}
        v-col
          y-checkbox(v-model="processingNotArranged" :color="$vuetify.theme.themes[$theme].info500")
            template(v-slot:label)
              div.p2.my-auto {{ $t('not_arranged_yet') }}
    div.mt-2
      y-checkbox(v-model="ready" :color="$vuetify.theme.themes[$theme].info500")
        template(v-slot:label)
          div.p2.my-auto {{ $t('ready') }}
    template(v-if="ready")
      v-row.mt-2(no-gutters)
        v-col(cols="1")
        v-col
          y-checkbox(v-model="readyArranged" :color="$vuetify.theme.themes[$theme].info500")
            template(v-slot:label)
              div.p2.my-auto {{ $t('arranged') }}
        v-col
          y-checkbox(v-model="readyNotArranged" :color="$vuetify.theme.themes[$theme].info500")
            template(v-slot:label)
              div.p2.my-auto {{ $t('not_arranged_yet') }}
    
</template>

<script>
export default {
  name: 'StatusOrder',
  props: ['parentProcessingOrder', 'parentReadyOrder'],
  data: () => ({
    processing: false,
    processingArranged: false,
    processingNotArranged: false,
    ready: false,
    readyArranged: false,
    readyNotArranged: false,
  }),
  computed: {
    processingOrder: {
      get () {
        return this.parentProcessingOrder
      },
      set (newValue) {
        this.$emit('update:parentProcessingOrder', newValue)
      }
    },
    readyOrder: {
      get () {
        return this.parentReadyOrder
      },
      set (newValue) {
        this.$emit('update:parentReadyOrder', newValue)
      }
    },
    processingArray () {
      let data = []
      if (this.processingArranged) {
        data.push('arranged')
      }
      if (this.processingNotArranged) {
        data.push('not-arranged')
      }
      return data
    },
    readyArray () {
      let data = []
      if (this.readyArranged) {
        data.push('arranged')
      }
      if (this.readyNotArranged) {
        data.push('not-arranged')
      }
      return data
    }
  },
  watch: {
    processing (val) {
      if (val) {
        if (!this.processingArranged && !this.processingNotArranged) {
          this.processingArranged = true
          this.processingNotArranged = true
        }
      } else {
        this.processingArranged = false
        this.processingNotArranged = false
      }
    },
    ready (val) {
      if (val) {
        if (!this.readyArranged && !this.readyNotArranged) {
          this.readyArranged = true
          this.readyNotArranged = true
        }
      } else {
        this.readyArranged = false
        this.readyNotArranged = false
      }
    },
    processingArray (val) {
      this.processingOrder = val
      if (val.length === 0) {
        this.processing = false
      }
    },
    readyArray (val) {
      this.readyOrder = val
      if (val.length === 0) {
        this.ready = false
      }
    },
    processingOrder (val) {
      if (val.length > 0) {
        this.processing = true
        if (val.filter(f => f === 'arranged').length > 0) {
          this.processingArranged = true
        }
        if (val.filter(f => f === 'not-arranged').length > 0) {
          this.processingNotArranged = true
        }
      } else {
        this.processing = false
      }
    },
    readyOrder (val) {
      this.ready = true
      if (val.length > 0) {
        if (val.filter(f => f === 'arranged').length > 0) {
          this.readyArranged = true
        }
        if (val.filter(f => f === 'not-arranged').length > 0) {
          this.readyNotArranged = true
        }
      } else {
        this.ready = false
      }
    }
  },
  mounted () {
    if (this.processingOrder && this.processingOrder.length > 0) {
      if (this.processingOrder.filter(f => f === 'arranged').length > 0) {
        this.processingArranged = true
      }
      if (this.processingOrder.filter(f => f === 'not-arranged').length > 0) {
        this.processingNotArranged = true
      }
    }
    if (this.readyOrder && this.readyOrder.length > 0) {
      if (this.readyOrder.filter(f => f === 'arranged').length > 0) {
        this.readyArranged = true
      }
      if (this.readyOrder.filter(f => f === 'not-arranged').length > 0) {
        this.readyNotArranged = true
      }
    }
  }
}
</script>